import { Paper } from '@material-ui/core';
import { makeStyles, Theme } from '@material-ui/core/styles';
import DataLabel from 'src/components/ui/card/DataLabel';
import { Site } from 'src/models/site';
import { borderRadius } from 'src/data/borders';

interface UserInfoCardProps {
  site: Site;
}

const EmptyState = '-';

const UserInfoCard = ({ site }: UserInfoCardProps) => {
  const classes = useStyles();

  return (
    <Paper variant="outlined" className={classes.paper}>
      <div className={classes.gridContainer}>
        <div className={classes.gridItem}>
          <DataLabel
            label="Installer"
            value={site.installerCompanyName || EmptyState}
            noMargin
            truncate
            withTooltip
          />
        </div>
        <div className={classes.gridItem}>
          <DataLabel
            label="End user"
            value={site.endUserName || EmptyState}
            noMargin
            truncate
            withTooltip
          />
        </div>
      </div>
    </Paper>
  );
};

const useStyles = makeStyles<Theme>((theme) => ({
  paper: {
    padding: '16px',
    width: '100%',
    backgroundColor: '#fff',
    borderRadius: borderRadius.md,
  },
  gridContainer: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '24px',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    minWidth: 0, // This is important for text truncation
  },
  gridItem: {
    minWidth: 0, // This is important for text truncation
  },
}));

export default UserInfoCard;
